import React from "react";
import NoDataIcon from "../../assets/svgs/no-data.svg";

interface NoDataProps {
  header?: string;
  paragraph?: string;
}

const NoData: React.FC<NoDataProps> = ({ header, paragraph }) => {
  return (
    <div className="flex flex-col justify-center mt-10">
      <div className="flex justify-center">
        <img src={NoDataIcon} alt="no-data-icon" className="text-red-500" />
      </div>
      <div className="text-center">
        <p className="text-primaryBlack text-base font-semibold my-4">
          {header}
        </p>
        <p className="text-[#4F4F4F] font-normal text-sm">{paragraph}</p>
      </div>
    </div>
  );
};

export default NoData;
